import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	isLoading: false,
    usernameErr: false,
    userNotFoundErr: false,
    emailSent: false,
    resetSuccess: false,
    successMessage: '',
    showSuccessMessage: false,
    userNotFoundMessage: '',
    showUserNotFound: false,
}

const getters = {

}


// mutations
const mutations = {
	TOGGLE_BOOLEAN_STATE(state, {key, bool}){
		eval('state.' + key + ' = bool');
	},

	SET_MESSAGE (state, {key, message}){
		eval('state.' + key + ' = message');
	},
}

// actions
const actions = {
	setBoolean({commit}, {key, bool}){
		commit('TOGGLE_BOOLEAN_STATE', {key: key, bool: bool});
	},

	forgotPassword({commit, state, rootState}, user){
		var url = rootState.auth.l+'forgot-password';

		var passwordResetLink = rootState.global.baseURL+'/password-reset';

		var data = {
			username: user.username,
			resetLink: passwordResetLink
		}
        axios.post(url, data)
        .then(response => {
        	//console.log(response);
			commit('TOGGLE_BOOLEAN_STATE', {key: 'isLoading', bool: false});
			commit('TOGGLE_BOOLEAN_STATE', {key: 'showSuccessMessage', bool: true});
        })   
        .catch((error) => {
            if(error.response.status === 404){
            	var message = 'Username not found.'
				commit('TOGGLE_BOOLEAN_STATE', {key: 'showUserNotFound', bool: true});
				commit('SET_MESSAGE', {key: 'userNotFoundMessage', message: message});

            }
			commit('TOGGLE_BOOLEAN_STATE', {key: 'isLoading', bool: false});
        });
	},
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
	actions
}